var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "documents-file-icon 1",
    clipPath: "url(#clip0_7505_1334)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26 28C26 29.1 25.1 30 24 30H4C2.9 30 2 29.1 2 28V4C2 2.9 2.9 2 4 2H16V11C16 11.6 16.4 12 17 12H26V14H28V11L27.3 10.3L17.7 0.7L17 0H4C1.8 0 0 1.8 0 4V28C0 30.2 1.8 32 4 32H24C26.2 32 28 30.2 28 28V27H26V28ZM18 3.8L24.2 10H18V3.8Z",
    fill: "#1B1C1F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.5 18.4002V17.2002H13.4V24.3002H14.9V21.5002H17.4V20.3002H14.9V18.4002H17.5Z",
    fill: "#1B1C1F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M20.4 17.2002H18.9V24.3002H20.4V17.2002Z",
    fill: "#1B1C1F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M22.2 17.2002V24.3002H26.6V23.1002H23.8V17.2002H22.2Z",
    fill: "#1B1C1F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M32 18.4002V17.2002H27.9V24.3002H32V23.1002H29.4V21.2002H31.8V20.0002H29.4V18.4002H32Z",
    fill: "#1B1C1F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7505_1334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.eca4fe64c79064cdb91c1f0f77b84540.svg";
export { ForwardRef as ReactComponent };